import axios from "axios";
import * as types from '../constants/ActionTypes'

// Url's
const getCollectionItemsUrl = `${process.env.REACT_APP_API_URL}mobileshop/csacatalog/get-shop-collection-now`;

// Actions
const collectionItemsSuccess = products => ({
  type: types.COLLECTIONITEMS_SUCCESS,
  products
});

// const collectionItemsMoreSuccess = products => ({
//   type: types.COLLECTIONITEMSMORE_SUCCESS,
//   products
// });

const collectionItemsRequested = () => ({
  type: types.COLLECTIONITEMS_REQUEST
});


const collectionItemsFailure = error => ({
  type: types.COLLECTIONITEMS_FAILURE,
  error
});


// API
export const getcollectionItems = (options) => {
  return dispatch => {
    dispatch(collectionItemsRequested());
    axios.get(getCollectionItemsUrl, {
      params: {
        connection_id: options.connection_id,
        collection_id: options.collection_id
      },
    })
      .then(res => {
        if (res.data.ack === "Success") {
          dispatch(collectionItemsSuccess(res.data.results));
        } else if (res.data.ack === "Failure") {
          dispatch(collectionItemsFailure(res.data.status));
        }
      })
      .catch(err => {
        throw err;
        // dispatch(addTodoFailure(err.message));
      });
  };
};

// export const getMoreCollectionItems = (options) => {
//   
//   return dispatch => {
//     dispatch(collectionItemsRequested());
//     axios.get(getCollectionItemsUrl, {
//       params: {
//         connection_id: options.connection_id,
//         location: options.location,
//         store_id: options.store_id,
//         brand_code: options.brand_code,
//         category_id: options.category_id,
//         gender_id: options.gender_id,
//         collection_id: options.collection_id,
//         bar_code: options.bar_code,
//         new_arrivals: options.new_arrivals,
//         price_start_range: options.price_start_range,
//         price_end_range: options.price_end_range,
//         size_id: options.size_id,
//         color_id: options.color_id,
//         page: options.page
//       },
//     })
//       .then(res => {
//         if (res.data.ack === "Success") {
//           dispatch(collectionItemsMoreSuccess(res.data.results));
//         } else if (res.data.ack === "Failure") {
//           dispatch(collectionItemsFailure(res.data.status));
//         }
//       })
//       .catch(err => {
//         throw err;
//         // dispatch(addTodoFailure(err.message));
//       });
//   };
// };
